import {
  PhasrCategoriesWidgetTemplateWebComponent,
  PhasrTamperingToolsWebComponent,
  PhasrRemoteAdminToolsWebComponent,
  PhasrMinersWebComponent,
  PhasrHackToolsWebComponent,
  PhasrOffLandBinariesWebComponent,
} from './component/PhasrCategoriesWidgetTemplateWebComponent';

export {
  PhasrCategoriesWidgetTemplateWebComponent,
  PhasrTamperingToolsWebComponent,
  PhasrRemoteAdminToolsWebComponent,
  PhasrMinersWebComponent,
  PhasrHackToolsWebComponent,
  PhasrOffLandBinariesWebComponent,
};
